import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";

import Layout from "../components/layout";
import CareersModal from "../components/careersModal";
import SalesModal from "../components/salesModal";
import MarketingModal from "../components/marketingModal";
import EventsModal from "../components/eventsModal";
import PartnershipsModal from "../components/partnershipsModal";
import salesImg from "../../static/images/contact/sales.svg";
// import marketingImg from "../../static/images/contact/marketing.svg";
// import eventsImg from "../../static/images/contact/events.svg";
import partnershipImg from "../../static/images/contact/partnership.svg";
import careersImg from "../../static/images/contact/careers.svg";
// import resourcesImg from "../../static/images/contact/resources.svg";

import { getVisiblePercentage } from "../utilities/elementUtilities";

import { assignActiveElement } from "../utilities/elementUtilities";

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      salesModalOpen: false,
      marketingModalOpen: false,
      eventsModalOpen: false,
      partnershipsModalOpen: false,
      careersModalOpen: false,
    };
    this.openSalesModal = this.openSalesModal.bind(this);
    this.closeSalesModal = this.closeSalesModal.bind(this);
    this.openMarketingModal = this.openMarketingModal.bind(this);
    this.closeMarketingModal = this.closeMarketingModal.bind(this);
    this.openEventsModal = this.openEventsModal.bind(this);
    this.closeEventsModal = this.closeEventsModal.bind(this);
    this.openPartnershipsModal = this.openPartnershipsModal.bind(this);
    this.closePartnershipsModal= this.closePartnershipsModal.bind(this);
    this.openCareersModal = this.openCareersModal.bind(this);
    this.closeCareersModal = this.closeCareersModal.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener("resize", this.handleScroll);
    this.handleScroll();
  }

  handleScroll = () => {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (width > 1050) {
      var contact_heading = document.getElementById('contact-heading');

      let percentage = getVisiblePercentage(contact_heading);

      /*
        based on value of percentage change style of dots
      */

      var navigationDots = document.querySelectorAll("a.dot-link");
      // console.log(navigationDots);
      for (var i = 0, max = navigationDots.length; i < max; i++) {
        if (percentage > 5) {
          navigationDots[i].className = navigationDots[i].className.replace(/\bnews\b/g, "");
        } else {
          navigationDots[i].classList.add("news");
        }
      }

      var contact_us_dark_section = document.getElementById('contact-us-dark-section');
      var dark_section_percentage = getVisiblePercentage(contact_us_dark_section);

      for (var k = 0, max_second = navigationDots.length; k < max_second; k++) {
        if (dark_section_percentage < 30) {
          navigationDots[k].className = navigationDots[k].className.replace(/\bnews\b/g, "");
        } else {
          navigationDots[k].classList.add("news");
        }
      }

    }

    var sectionList = [
      document.getElementById('contact-box-first-row'),
      document.getElementById('contact-box-second-row'),
      // document.getElementById('desktop-map-section'),
    ];
    assignActiveElement(sectionList);

  }

  openSalesModal = () => {
    // this.setState({ salesModalOpen: true });
    // window.location.href="https://beta.bld.ai/launch";
    window.open("https://beta.bld.ai/launch", "_blank");
  }

  closeSalesModal = () => {
    this.setState({ salesModalOpen: false });
  }

  openMarketingModal = () => {
    this.setState({ marketingModalOpen: true });
  }

  closeMarketingModal = () => {
    this.setState({ marketingModalOpen: false });
  }

  openEventsModal = () => {
    this.setState({ eventsModalOpen: true });
  }

  closeEventsModal = () => {
    this.setState({ eventsModalOpen: false });
  }

  openPartnershipsModal = () => {
    // this.setState({ partnershipsModalOpen: true });
    // window.location.href="https://beta.bld.ai/invest";
    window.open("https://beta.bld.ai/invest", "_blank");
  }

  closePartnershipsModal = () => {
    this.setState({ partnershipsModalOpen: false });
  }

  openCareersModal = () => {
    // this.setState({ careersModalOpen: true });
    // window.location.href="https://beta.bld.ai/join";
    window.open("https://beta.bld.ai/join", "_blank");
  }

  closeCareersModal = () => {
    this.setState({ careersModalOpen: false });
  }

  render() {
    return(  
      <Layout footerMargin={false} layoutClassName="contact-page">
        <div className="side-dots-nav">
          <ul className="nav-items">
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="contact-heading"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="contact-us-light-section"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            {/**
            <li className="nav-item hide-on-desktop">
              <Link
                  activeClass="active"
                  to="marketing-contact-box"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item hide-on-desktop">
              <Link
                  activeClass="active"
                  to="event-contact-box"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
             */}
            <li className="nav-item hide-on-desktop">
              <Link
                  activeClass="active"
                  to="partnership-contact-box"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item hide-on-desktop">
              <Link
                  activeClass="active"
                  to="careers-contact-box"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            {/**
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="resources-contact-box"
                  spy={true}
                  smooth={true}
                  offset={-170}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
             */}
            {/* <li className="nav-item hide-on-mobile">
              <Link
                  activeClass="active"
                  to="desktop-map-section"
                  spy={true}
                  smooth={true}
                  offset={-170}
                  duration= {500}
                  className="dot-link"
                  onSetActive={this.handleScroll}
                  onSetInactive={this.handleScroll}
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li> */}
          </ul>
        </div>
        <SalesModal
          modalOpen={this.state.salesModalOpen}
          closeModal={this.closeSalesModal}
        />
        <MarketingModal
          modalOpen={this.state.marketingModalOpen}
          closeModal={this.closeMarketingModal}
        />
        <EventsModal
          modalOpen={this.state.eventsModalOpen}
          closeModal={this.closeEventsModal}
        />
        <PartnershipsModal
          modalOpen={this.state.partnershipsModalOpen}
          closeModal={this.closePartnershipsModal}
        />
        <CareersModal
          modalOpen={this.state.careersModalOpen}
          closeModal={this.closeCareersModal}
        />
        <section className="section full contact-heading first" id="contact-heading">
          <p className="heading">Let’s start the conversation.</p>
        </section>
        <div id="contact-section">
          <section className="section contact contact-us-light-section display" id="contact-us-light-section">
            <Container id="contact-us">
              <Row>
                <Col xs={12}>
                <div className="contact-us-intro text-center">
                  <p>The world’s leading enterprises are using <strong>bld.ai</strong> to create remarkable conversational AI experiences. Find out why by getting in touch with one of our expert teams.</p>
                </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section contact contact-us-dark-section display" id="contact-us-dark-section">
            <Container>
              <Row>
                <Col xs={12}>
                  <div className="contact-boxes">
                    <Row id="contact-box-first-row" className="sectionDiv">
                      <Col xs={12} lg={4} className="mb-5">
                      <div className="contact-box" id="sales-contact-box">
                          <div className="contact-box-title-section">
                            <div className="contact-box-icon">
                              <img src={salesImg} alt="Sales Icon"/>
                            </div>
                            <div className="contact-box-title">
                              <h4 className="caps dark-blue px18">SALES</h4>
                            </div>
                          </div>
                          <div className="contact-box-description contact-box-upper-row">
                            Schedule a demo and let us show you the solutions we can build for your pressing business needs.
                          </div>
                          <div className="contact-box-link" onClick={this.openSalesModal} onKeyDown={this.openSalesModal} role="button" tabIndex={-1}>
                            <div data-toggle="modal" data-target="#salesModal" className="pseudo-link">
                              <span>Contact Sales</span>
                            </div>
                          </div>
                      </div>
                      </Col>
                      <Col xs={12} lg={4} className="mb-5">
                      <div className="contact-box" id="partnership-contact-box">
                          <div className="contact-box-title-section">
                            <div className="contact-box-icon">
                              <img src={partnershipImg} alt="Partnership Icon"/>
                            </div>
                            <div className="contact-box-title">
                              <h4 className="caps dark-blue px18">PARTNERSHIP</h4>
                            </div>
                          </div>
                          <div className="contact-box-description contact-box-upper-row">
                            Let us help each other build the future and harness the power of AI.
                          </div>
                          <div className="contact-box-link"  onClick={this.openPartnershipsModal} onKeyDown={this.openPartnershipsModal} role="button" tabIndex={-1}>
                            <div data-toggle="modal" data-target="#partnershipModal" className="pseudo-link">
                              <span>Partnership Inquiries</span>
                            </div>
                          </div>
                      </div>
                      </Col>
                      <Col xs={12} lg={4} className="mb-5">
                      <div className="contact-box" id="careers-contact-box">
                          <div className="contact-box-title-section">
                            <div className="contact-box-icon">
                              <img src={careersImg} alt="Careers Icon"/>
                            </div>
                            <div className="contact-box-title">
                              <h4 className="caps dark-blue px18">CAREERS</h4>
                            </div>
                          </div>
                          <div className="contact-box-description contact-box-upper-row">
                            We are always looking for people who are passionate about technology and helping the world.
                          </div>
                          <div className="contact-box-link"  onClick={this.openCareersModal} onKeyDown={this.openCareersModal} role="button" tabIndex={-1}>
                            <div data-toggle="modal" data-target="#careersModal" className="pseudo-link">
                              <span>Join us</span>
                            </div>
                          </div>
                      </div>
                      </Col>
                    </Row>
                    {/**
                    <Row id="contact-box-second-row" className="sectionDiv justify-content-lg-center">
                      <Col xs={12} lg={4} className="mb-5">
                      <div className="contact-box" id="event-contact-box">
                          <div className="contact-box-title-section">
                            <div className="contact-box-icon">
                              <img src={eventsImg} alt="Events Icon"/>
                            </div>
                            <div className="contact-box-title">
                              <h4 className="caps dark-blue px18">EVENT SPEAKING & SPONSORSHIPS</h4>
                            </div>
                          </div>
                          <div className="contact-box-description contact-box-upper-row">
                            Would you like bld.ai to sponsor or speak at your event? Fill out this form and a member of our team will be in touch with you shortly.
                          </div>
                          <div className="contact-box-link" onClick={this.openEventsModal}>
                            <div data-toggle="modal" data-target="#eventModal" className="pseudo-link">
                              <span>Event Inquiries</span>
                            </div>
                          </div>
                      </div>
                      </Col>
                      <Col xs={12} lg={4} className="mb-5">
                      <div className="contact-box" id="marketing-contact-box">
                          <div className="contact-box-title-section">
                            <div className="contact-box-icon">
                              <img src={marketingImg} alt="Marketing Icon"/>
                            </div>
                            <div className="contact-box-title">
                              <h4 className="caps dark-blue px18">MARKETING</h4>
                            </div>
                          </div>
                          <div className="contact-box-description contact-box-upper-row">
                          Let’s do big things together. Get in touch with us to discuss press opportunities, advertisements, content or other related marketing opportunities.
                          </div>
                          <div className="contact-box-link" onClick={this.openMarketingModal}>
                            <div data-toggle="modal" data-target="#marketingModal" className="pseudo-link">
                              <span>Contact Marketing</span>
                            </div>
                          </div>
                      </div>
                      </Col>
                      <Col xs={12} lg={4} className="mb-5">
                      <div className="contact-box" id="resources-contact-box">
                          <div className="contact-box-title-section">
                            <div className="contact-box-icon">
                              <img src={resourcesImg} alt="Sales Icon"/>
                            </div>
                            <div className="contact-box-title">
                              <h4 className="caps dark-blue px18">RESOURCES</h4>
                            </div>
                          </div>
                          <div className="contact-box-description contact-box-lower-row">
                            Want to learn more? Check out the bld.ai resources library.
                          </div>
                          <div className="contact-box-link">
                            <a href="/contact/">View Resources</a>
                          </div>
                      </div>
                      </Col>
                    </Row>
                    */}
                  </div>
                </Col>
              </Row>
            </Container>
            {/*<div className="desktop-map-section sectionDiv"  id="desktop-map-section">
              <Container>
                <Row>
                  <Col xs={12} md={4}>
                    <div className="mobile-map-box mb-5">
                      <div className="city">U.S.A.</div>
                      <div className="office">Product Management</div>
                      <div className="address">Florida - South<br/>Michigan - Midwest
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className="mobile-map-box mb-5">
                      <div className="city">ISRAEL</div>
                      <div className="office">Data Science</div>
                      <div className="address">Haifa
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className="mobile-map-box mb-5">
                      <div className="city">PHILIPPINES</div>
                      <div className="office">Design & Development</div>
                      <div className="address">Quezon City
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>*/}
          </section>
        </div>
      </Layout>
    );
  }
}

export default (Contact);
